module.exports = __webpack_public_path__ + "assets/img/relative-to-start-time.jpg";